import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowTopRightOnSquareIcon as ExternalLinkIcon, LinkIcon, } from '@heroicons/react/24/outline';
import { useLinkProvider, useSiteManifest, useBaseurl, withBaseurl } from '@myst-theme/providers';
import { HoverPopover, LinkCard } from '../components/index.js';
import { WikiLink } from './wiki.js';
import { RRIDLink } from './rrid.js';
import { GithubLink } from './github.js';
import { MyST } from '../MyST.js';
function getPageInfo(site, path) {
    var _a;
    if (!site)
        return undefined;
    const [projectSlug, pageSlug] = path.replace(/^\//, '').split('/');
    const project = (_a = site.projects) === null || _a === void 0 ? void 0 : _a.find((p) => p.slug === projectSlug || (!p.slug && !pageSlug));
    if (!project)
        return undefined;
    return project.pages.find((p) => p.slug === (pageSlug || projectSlug));
}
function InternalLink({ url, children }) {
    const Link = useLinkProvider();
    const site = useSiteManifest();
    const page = getPageInfo(site, url);
    const baseurl = useBaseurl();
    const skipPreview = !page || (!page.description && !page.thumbnail);
    if (!page || skipPreview) {
        return (_jsx(Link, { to: withBaseurl(url, baseurl), prefetch: "intent", children: children }));
    }
    return (_jsx(HoverPopover, { card: _jsx(LinkCard, { internal: true, url: url, title: page.title, description: page.description, thumbnail: page.thumbnailOptimized || page.thumbnail }), children: _jsx(Link, { to: withBaseurl(url, baseurl), prefetch: "intent", children: children }) }));
}
export const link = ({ node }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const internal = (_a = node.internal) !== null && _a !== void 0 ? _a : false;
    const protocol = node.protocol;
    switch (protocol) {
        case 'wiki':
            return (_jsx(WikiLink, { url: node.url, page: (_b = node.data) === null || _b === void 0 ? void 0 : _b.page, wiki: (_c = node.data) === null || _c === void 0 ? void 0 : _c.wiki, children: _jsx(MyST, { ast: node.children }) }));
        case 'github':
            return (_jsx(GithubLink, { kind: (_d = node.data) === null || _d === void 0 ? void 0 : _d.kind, url: node.url, org: (_e = node.data) === null || _e === void 0 ? void 0 : _e.org, repo: (_f = node.data) === null || _f === void 0 ? void 0 : _f.repo, raw: (_g = node.data) === null || _g === void 0 ? void 0 : _g.raw, file: (_h = node.data) === null || _h === void 0 ? void 0 : _h.file, from: (_j = node.data) === null || _j === void 0 ? void 0 : _j.from, to: (_k = node.data) === null || _k === void 0 ? void 0 : _k.to, issue_number: (_l = node.data) === null || _l === void 0 ? void 0 : _l.issue_number, children: _jsx(MyST, { ast: node.children }) }));
        case 'rrid':
            return _jsx(RRIDLink, { rrid: (_m = node.data) === null || _m === void 0 ? void 0 : _m.rrid });
        default:
            if (internal) {
                return (_jsx(InternalLink, { url: node.url, children: _jsx(MyST, { ast: node.children }) }));
            }
            return (_jsx("a", { target: "_blank", href: node.url, rel: "noreferrer", children: _jsx(MyST, { ast: node.children }) }));
    }
};
export const linkBlock = ({ node }) => {
    var _a;
    const iconClass = 'self-center transition-transform flex-none ml-3';
    const containerClass = 'flex-1 p-4 my-5 block border font-normal hover:border-blue-500 dark:hover:border-blue-400 no-underline hover:text-blue-600 dark:hover:text-blue-400 text-gray-600 dark:text-gray-100 border-gray-200 dark:border-gray-500 rounded shadow-sm hover:shadow-lg dark:shadow-neutral-700';
    const internal = (_a = node.internal) !== null && _a !== void 0 ? _a : false;
    const nested = (_jsxs("div", { className: "flex h-full align-middle", children: [_jsxs("div", { className: "flex-grow", children: [node.title, _jsx("div", { className: "text-xs text-gray-500 dark:text-gray-400", children: _jsx(MyST, { ast: node.children }) })] }), internal && _jsx(LinkIcon, { width: "1.5rem", height: "1.5rem", className: iconClass }), !internal && _jsx(ExternalLinkIcon, { width: "1.5rem", height: "1.5rem", className: iconClass })] }));
    if (internal) {
        return (_jsx("a", { href: node.url, className: containerClass, children: nested }));
    }
    return (_jsx("a", { className: containerClass, target: "_blank", rel: "noopener noreferrer", href: node.url, children: nested }));
};
const LINK_RENDERERS = {
    link,
    linkBlock,
};
export default LINK_RENDERERS;
